import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "recent-name text-body-1" }
const _hoisted_2 = { class: "recent-place text-body-2 text-medium-emphasis" }
const _hoisted_3 = { class: "recent-when text-caption text-medium-emphasis" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_color_accent = _resolveComponent("ontos-color-accent")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "recent-row",
    to: _ctx.to
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ontos_color_accent, {
        vertical: "",
        color: _ctx.instanceColorOf(_ctx.item),
        class: "recent-accent"
      }, null, 8, ["color"]),
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.item._identifier || `#${_ctx.item._instance}`), 1),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.place), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.item._updatedAt ? _ctx.relativeTime(_ctx.item._updatedAt) : ''), 1)
    ]),
    _: 1
  }, 8, ["to"]))
}